var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckWhite = function SvgCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "M6.127 12.189a.83.83 0 0 1-.578.23.83.83 0 0 1-.577-.23L.359 7.733a1.155 1.155 0 0 1 0-1.674l.578-.558a1.256 1.256 0 0 1 1.732 0l2.88 2.782L13.331.767a1.256 1.256 0 0 1 1.732 0l.578.558a1.155 1.155 0 0 1 0 1.673z"
  })));
};
export default SvgCheckWhite;